import React, { useState, useContext, useEffect } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import { BsPrinter } from "react-icons/bs";
//Srcs
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import CreateDisbursementDetails from "./CreateDisbursementDetails";
import DeleteDisbursement from "./DeleteDisbursement";
import PrintDisbursement from "./PrintDisbursement";
import { GET_DISBURSEMENT_BY_ID } from "../../Schema/Disbursement";

export default function DisbursementAction({ editData, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  let navigate = useNavigate();

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [checkData, setCheckData] = useState([]);

  const { refetch } = useQuery(GET_DISBURSEMENT_BY_ID, {
    variables: {
      id: editData?._id,
    },
    onCompleted: ({ getDisbursementId }) => {
      // console.log("getDisbursementId==>", getDisbursementId);
      setCheckData(getDisbursementId);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [editData?._id]);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {checkData?.disbursements?.length === 0 ? (
          <Tooltip title="delete" placement="top">
            <IconButton onClick={handleOpenDel}>
              <Box className="delete-container">
                <MdDelete className="delete-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        ) : (
          <>
            <Tooltip title="print" placement="top">
              <IconButton onClick={handleOpenEdit}>
                <Box className="update-container">
                  <BsPrinter className="update-icon" />
                </Box>
              </IconButton>
            </Tooltip>

            <Tooltip title="delete" placement="top">
              <IconButton onClick={handleOpenDel}>
                <Box className="delete-container">
                  <MdDelete className="delete-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          </>
        )}
      </Stack>

      <PrintDisbursement
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
      />
      
      <DeleteDisbursement
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      />
    </div>
  );
}
